@if (activeNavigationItem?.action == 'basicConfig') {
    <ei-structure-basic-component
            [structureId]="objectIdentifier.objectId"></ei-structure-basic-component>
}
@if (activeNavigationItem?.action == 'fields') {
    <ei-structure-fields-component
            [structureId]="objectIdentifier.objectId"
            [importTypeId]="importTypeId"></ei-structure-fields-component>
}
@if (activeNavigationItem?.action == 'searchFields') {
    <ei-structure-search-fields-component
            [structureId]="objectIdentifier.objectId"
            [importTypeId]="importTypeId"></ei-structure-search-fields-component>
}
@if (activeNavigationItem?.action == 'qlQueryParams') {
    <ei-structure-ql-query-params-component
            [structureId]="objectIdentifier.objectId"
            [importTypeId]="importTypeId"></ei-structure-ql-query-params-component>
}
@if (activeNavigationItem?.action == 'validationQlParams') {
    <ei-structure-validation-ql-params-component
            [structureId]="objectIdentifier.objectId"
            [importTypeId]="importTypeId"></ei-structure-validation-ql-params-component>
}
@if (activeNavigationItem?.action == 'conditionLogic') {
    <ei-structure-condition-logic-component
            [structureId]="objectIdentifier.objectId"
            [importTypeId]="importTypeId"></ei-structure-condition-logic-component>
}
